const B_1 = [
    {
        title: '预约开评标室',
        path: '/bidding/projectflow/fangan/kproom/list'
    }
]
export default {
    path: 'kproom',
    component: () => import(/*webpackChunkName: 'bidding-fa-fbyqs'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/fang-an/kproom/list'),
            meta: {
                title: '开评标室列表',
                bread: B_1
            },
        },
        {
            path:"form",
            component: () => import('@views/bidding/views/project-flow/fang-an/kproom/form'),
            meta: {
                title: '预约开评标室',
                bread: B_1
            },
        },
        {
            path:"detail",
            component: () => import('@views/bidding/views/project-flow/fang-an/kproom/detail'),
            meta: {
                title: '开评标室详情',
                bread: B_1
            },
        },
        
        
    ]
}